/** How many of the newest entries the sidebar menu lists above "Full changelog". */
export const WHATS_NEW_MENU_COUNT = 3;

/**
 * Ids of the entries newer than the one the user last saw. Entries come
 * newest first. With no marker, or a marker for an entry that no longer
 * exists, everything counts as unseen.
 */
export function unseenEntryIds(entries: ReadonlyArray<{ id: string }>, seenId: string | null): string[] {
  const ids = entries.map((entry) => entry.id);
  const seenAt = seenId ? ids.indexOf(seenId) : -1;

  return seenAt === -1 ? ids : ids.slice(0, seenAt);
}

/** "2026-10-30" → "30 Oct 2026", read as a calendar day so no timezone shifts it. */
export function formatWhatsNewDate(date: string): string {
  const [year, month, day] = date.split('-').map(Number);
  if (!year || !month || !day) return date;

  return new Date(year, month - 1, day).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
